import React, { useContext, useState } from "react";
import axios from "../../util/axios";
import { Context } from "../../component/Context/ErrorContext";
import { VscLoading } from "react-icons/vsc";
import { useNavigate } from "react-router-dom";

const ForgetPassword = () => {
  const [contact_email, setContactEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const { setError } = useContext(Context);
  const navigate = useNavigate();
  const [message, setMessage] = useState("");

  const submitHandler = (e: React.FormEvent) => {
    e.preventDefault();
    if (contact_email === "") {
      setError("Please enter your email");
      return;
    }
    setLoading(true);
    setMessage("");
    axios({
      URL: "/omw/subAdmin/forgot-password",
      method: "POST",
      data: { contact_email },
    })
      .then((res: any) => {
        if (res.data && res.data.status) {
          setMessage(
            res.data.message || "Password reset link sent to your email."
          );
        } else {
          setError(res.data.message || "Something went wrong.");
        }
      })
      .catch((e) => {
        setError(e.response?.data?.message || "Something went wrong.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div>
      <div
        className={
          "w-screen h-screen flex justify-center bg-gradient-to-t from-[#305FAA] to-[#17366D]"
        }
      >
        <div
          className={"flex flex-col w-full max-w-[1000px] pt-4 items-center"}
        >
          <img
            src={"/logo.png"}
            alt="logo"
            width={130}
            className={"self-start cursor-pointer"}
            onClick={() => navigate("/login")}
          />
          <div
            className={
              "flex flex-col flex-1 w-full justify-start items-center pt-32 max-w-[500px] px-4"
            }
          >
            <p
              className={
                "text-4xl text-white font-light text-center uppercase"
              }
            >
              FORGOT YOUR PASSWORD?
            </p>
            <p className={"text-white mt-4 text-center"}>
              Enter your email address and we'll send you a link to reset your
              password.
            </p>
            <form
              className={"w-full gap-5 mt-10 flex flex-col"}
              onSubmit={submitHandler}
            >
              <div className={"w-full flex flex-col items-start"}>
                <label
                  htmlFor={"contact_email"}
                  className={"text-white text-[1.125rem] font-bold"}
                >
                  EMAIL
                </label>
                <input
                  id={"contact_email"}
                  className={
                    "bg-white w-full rounded-[4px] p-2 outline-none h-12"
                  }
                  onChange={(e) => setContactEmail(e.target.value)}
                  value={contact_email}
                  disabled={loading}
                  type={"email"}
                />
              </div>
              {message && (
                <p className={"text-green-400 text-center"}>{message}</p>
              )}
              <div
                className={
                  "w-full flex flex-col items-center justify-center gap-4"
                }
              >
                <button
                  className={
                    "bg-[#43CB49] px-5 py-1 rounded text-white text-xl h-12 w-80 flex justify-center items-center hover:bg-[#3d9c41]"
                  }
                  type={"submit"}
                  disabled={loading}
                >
                  {loading ? (
                    <VscLoading className={"animate-spin text-2xl"} />
                  ) : (
                    "Send Password Reset Link"
                  )}
                </button>
                <a
                  className={"cursor-pointer text-white text-sm"}
                  href={"/login"}
                >
                  Back to Login
                </a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ForgetPassword;
